import { render, staticRenderFns } from "./TheHeaderDropdownAccnt.vue?vue&type=template&id=40163969&scoped=true&"
import script from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownAccnt.vue?vue&type=style&index=0&id=40163969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40163969",
  null
  
)

export default component.exports